<template>
    <az-call-to-action dark
                       :active="true"
                       :outline="false"
                       @click="acessarProcessoDigital">
        Processo Digital
    </az-call-to-action>
</template>

<script>
import {mapState} from 'vuex'
export default {
  name: 'LicitacaoAtualizacaoAcoesProcessoDigital',
  computed: {
      ...mapState(['licitacao'])
  },
  methods:{
    acessarProcessoDigital(){
      const url = this.licitacao.processoVirtualUrl
      window.open(url, '_blank').focus();
    }
  }
}
</script>